import tinycolor from 'tinycolor2';

import { TColorStateRetriever, TActionDefinition } from '../types';

/**

 * Este método acepta un color y aplica el estado pasado como segundo

 * parámetro. De esta forma se puede obtener el color correspondiente al estado

 * calculado automáticamente por la aplicación.

 */

const getOneColorState: TColorStateRetriever = (color, state, palette) => {
  if (typeof color !== 'string') return '';
  if (state === 'default') return color;

  const actualState = state === 'checked' ? 'selected' : state;

  const opacity: number = palette.action[
    `${state}Opacity` as keyof TActionDefinition
  ] as number;

  return tinycolor

    .mix(
      color,

      tinycolor(color).isLight()
        ? palette.action[actualState].light
        : palette.action[actualState].dark,

      100 * opacity,
    )

    .toRgbString();
};

export default getOneColorState;
